import { init } from "../init";
import { JiraSoftwarePage } from "../pages/software/jira/anchors/jira-software-page";
init(JiraSoftwarePage);
